
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'STAR',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/STAR.vue